export const SCHEDULE_DATA = {
    currentWeek: "November 11 - November 17, 2024",
    className: "Grade 12A",
    subject: "Calculus I",
    days: [
      {
        date: "Monday, Nov 11",
        classes: [
          {
            id: 1,
            time: "08:30 - 09:45",
            subject: "Calculus I",
            topic: "Chain Rule",
            class: "Grade 12A",
            students: 25,
            room: "Room 301",
            materials: ["Textbook Ch.5", "Practice Worksheets"],
            homeworkDue: true,
            objectives: [
              "Understand chain rule concept",
              "Apply to composite functions",
              "Solve real-world problems"
            ],
            homeworkDetails: {
              type: "Problem Set",
              problems: "Chapter 5: #15-30",
              dueNext: "Wednesday"
            }
          },
          {
            id: 2,
            time: "10:00 - 11:15",
            subject: "Algebra II",
            topic: "Quadratic Functions",
            class: "Grade 11B",
            students: 22,
            room: "Room 303",
            materials: ["Function Graphs", "Quiz Papers"],
            homeworkDue: false,
            objectives: [
              "Graph quadratic functions",
              "Find vertex and intercepts",
              "Apply quadratic formula"
            ],
            homeworkDetails: {
              type: "Worksheet",
              problems: "Quadratic Applications",
              dueNext: "Friday"
            }
          }
        ]
      },
      {
        date: "Tuesday, Nov 12",
        classes: [
          {
            id: 3,
            time: "09:00 - 10:15",
            subject: "Pre-Calculus",
            topic: "Trigonometric Functions",
            class: "Grade 11A",
            students: 24,
            room: "Room 302",
            materials: ["Trigonometry Set", "Practice Problems"],
            homeworkDue: true,
            objectives: [
              "Define trig ratios",
              "Graph sine and cosine",
              "Solve trig equations"
            ],
            homeworkDetails: {
              type: "Online Assignment",
              problems: "Trig Practice Set",
              dueNext: "Thursday"
            }
          }
        ]
      },
      {
        date: "Wednesday, Nov 13",
        classes: [
          {
            id: 4,
            time: "08:30 - 09:45",
            subject: "Calculus I",
            topic: "Integration Basics",
            class: "Grade 12A",
            students: 25,
            room: "Room 301",
            materials: ["Integration Handout", "Calculator"],
            homeworkDue: false,
            objectives: [
              "Introduce integration concept",
              "Practice basic integrals",
              "Understand area under curve"
            ],
            homeworkDetails: {
              type: "Problem Set",
              problems: "Integration Basics #1-20",
              dueNext: "Monday"
            }
          },
          {
            id: 5,
            time: "13:00 - 14:15",
            subject: "Algebra II",
            topic: "Complex Numbers",
            class: "Grade 11B",
            students: 22,
            room: "Room 303",
            materials: ["Complex Number Guide"],
            homeworkDue: true,
            objectives: [
              "Define complex numbers",
              "Add and multiply complex numbers",
              "Find complex solutions"
            ],
            homeworkDetails: {
              type: "Practice Problems",
              problems: "Complex Numbers Set A",
              dueNext: "Friday"
            }
          }
        ]
      },
      {
        date: "Thursday, Nov 14",
        classes: [
          {
            id: 6,
            time: "10:30 - 11:45",
            subject: "Pre-Calculus",
            topic: "Polar Coordinates",
            class: "Grade 11A",
            students: 24,
            room: "Room 302",
            materials: ["Coordinate Systems Worksheet"],
            homeworkDue: false,
            objectives: [
              "Convert between coordinate systems",
              "Graph polar equations",
              "Find areas in polar form"
            ],
            homeworkDetails: {
              type: "Worksheet",
              problems: "Polar Coordinates Set",
              dueNext: "Monday"
            }
          }
        ]
      },
      {
        date: "Friday, Nov 15",
        classes: [
          {
            id: 7,
            time: "09:00 - 10:15",
            subject: "Calculus I",
            topic: "Integration Applications",
            class: "Grade 12A",
            students: 25,
            room: "Room 301",
            materials: ["Application Problems", "Group Work Sheet"],
            homeworkDue: true,
            objectives: [
              "Apply integration to area",
              "Find volumes of revolution",
              "Solve real-world problems"
            ],
            homeworkDetails: {
              type: "Group Project",
              problems: "Real-world Applications",
              dueNext: "Next Friday"
            }
          },
          {
            id: 8,
            time: "11:00 - 12:15",
            subject: "Algebra II",
            topic: "Function Transformations",
            class: "Grade 11B",
            students: 22,
            room: "Room 303",
            materials: ["Graph Paper", "Transformation Rules"],
            homeworkDue: true,
            objectives: [
              "Translate functions",
              "Scale and reflect functions",
              "Combine transformations"
            ],
            homeworkDetails: {
              type: "Digital Assignment",
              problems: "Transform Practice",
              dueNext: "Tuesday"
            }
          }
        ]
      }
    ],
    stats: {
      totalClasses: 8,
      totalStudents: 71,
      homeworkDueCount: 5,
      upcomingAssessments: 3
    }
  };